<template>
  <div class="checkbox_container">
    <img :src="imageSrc" :width="size" :height="size" @click="handleClick" />
    <label v-show="!!text" :class="typo" @click="handleLabelClick">{{
      text
    }}</label>
    <div @click="handleLabelClick">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: 'check' | 'radio',
      default: 'check'
    },
    size: {
      type: Number,
      default: 20
    },
    typo: {
      type: String,
      default: 'body_7_M'
    },
    text: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function
    },
    onLabelClick: {
      type: Function
    }
  },
  computed: {
    imageSrc () {
      return this.value
        ? `/static/icons/${
          this.type === 'radio' ? 'radio_checked.svg' : 'fill_checked.svg'
        }`
        : `/static/icons/${
          this.type === 'radio' ? 'radio_non_checked.svg' : 'non_checked.svg'
        }`
    }
  },
  methods: {
    handleClick () {
      if (this.onClick) {
        this.onClick(!this.value)
      }
    },
    handleLabelClick () {
      if (this.onLabelClick) {
        this.onLabelClick(!this.value)
      } else if (this.onClick) {
        this.onClick(!this.value)
      }
    }
  }
}
</script>

<style scoped>
.checkbox_container {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiCheckBox.vue